import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.sarvagyastudentsathi.app";
const APP_DEEP_LINK_BASE = "https://sarvagyastudentsathi.com";

const AppBanner = () => {
  const [show, setShow] = useState(false);
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (Capacitor.isNativePlatform()) return;
    const isFromExternalLink = document.referrer === "" && window.location.pathname !== "/" && window.location.pathname !== "/home";
    const dismissed = sessionStorage.getItem("appBannerDismissed");
    if (isFromExternalLink && !dismissed) {
      setCurrentPath(window.location.pathname + window.location.search);
      setShow(true);
    }
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem("appBannerDismissed", "true");
    setShow(false);
  };

  const handleOpenApp = () => {
    const deepLink = APP_DEEP_LINK_BASE + currentPath;
    window.location.href = deepLink;
    setTimeout(() => {
      window.location.href = PLAY_STORE_URL;
    }, 2000);
    handleDismiss();
  };

  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-white border-b border-gray-200 shadow-lg px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <img src="/sarvagyalogo.png" alt="Sarvagya" className="w-10 h-10 rounded-xl object-cover" />
          <div>
            <p className="font-bold text-gray-800 text-sm leading-tight">Sarvagya : Student Sathi</p>
            <p className="text-gray-500 text-xs">App में बेहतर अनुभव पाएं</p>
          </div>
        </div>
        <button onClick={handleOpenApp} className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-3 py-2 rounded-lg transition shrink-0">
          App में खोलें
        </button>
      </div>
      <button onClick={handleDismiss} className="mt-2 text-gray-400 hover:text-gray-600 text-xs underline w-full text-center">
        Website पर जारी रखें
      </button>
    </div>
  );
};

export default AppBanner;